<template>
    <div class="permisos">
        <vs-row class="p-4">
            <vs-col w="12" class="lineTitulo mb-2">
                <h5><strong>DESCARGAR MATERIAL</strong></h5>
            </vs-col>
            <p class="sinInfo" v-if="!documento[0]">Sin información</p>
            <details v-for="(doc, d) in documento" :key="d" class="lineSub">
                <summary>
                    <strong>{{doc.institucion}}</strong>
                </summary>
                <div>
                    <h6 class="mb-0"><small>CICLO ESCOLAR: </small>{{doc.registro.ciclo_escolar}}</h6>
                    <h6 class="mb-4"><small>PROGRAMA: </small>{{doc.programa}}</h6>
                    <div v-for="(arch, a) in doc.documentos" :key="a" class="mb-3 lineSub">
                        <h5 class="mb-0"><strong>{{arch.codigo_sesion}}</strong></h5>
                        <vs-row>
                            <vs-col sm="12" lg="4" v-for="(file, f) in arch.documentos" :key="f">
                                <div class="documentoBox shadow-sm">
                                    <h6 class="mb-0" style="word-break: break-all"><strong>{{file.filename}}</strong></h6>
                                    <hr>
                                    <h6><small><strong>FECHA LÍMITE DE VISUALIZACIÓN</strong></small></h6>
                                    <p>{{file.fecha_limite ? file.fecha_limite : 'Sin fecha límite'}}</p>
                                    <h6><small><strong>DESCRIPCIÓN:</strong></small></h6>
                                    <p>{{file.descripcion ? file.descripcion : 'Sin descripción'}}</p>
                                    <vs-button
                                        flat
                                        md-menu-trigger
                                        @click="getDocumentosDownload(file.id)"
                                    >
                                        Descargar documento
                                    </vs-button>
                                </div>
                            </vs-col>
                        </vs-row>
                    </div>
                </div>
                <!-- <vs-row>
                    <vs-col sm="12" lg="6"
                        :key="i"
                        v-for="(tr, i) in documentosGenerales"
                        :data="tr"
                    >
                        <div class="documentoBox shadow-sm">
                        <div class="d-flex justify-content-between">
                            <h6 class="mb-0"><strong>{{tr.nombre}}</strong></h6>
                        </div>
                        <hr>
                        <h6><small><strong>PROFESOR:</strong></small></h6>
                        <p>{{tr.profesor}}</p>
                        <h6><small><strong>FECHA LÍMITE DE VISUALIZACIÓN</strong></small></h6>
                        <p>{{tr.fecha_visualizacion}}</p>
                        <h6><small><strong>DESCRIPCIÓN:</strong></small></h6>
                        <p>{{tr.descripcion ? tr.descripcion : 'Sin descripción'}}</p>
                        <div class="d-flex justify-content-between">
                            <vs-button
                            success
                            flat
                            >
                            Descargar archivo
                            </vs-button>
                        </div>
                        </div>
                    </vs-col>
                </vs-row> -->
            </details>
            <!-- <vs-col w="12" v-for="(doc, d) in documento" :key="d" class="pb-2 pt-3 divisorWithLine">
                <h4><strong>{{doc.institucion}}</strong></h4>
                <p class="mb-0"><small><i>CICLO ESCOLAR:</i></small><strong>{{doc.registro.ciclo_escolar}}</strong></p>
                <p><small><i>PROGRAMA:</i></small><strong>{{doc.programa}}</strong></p>
                <div v-for="(arch, a) in doc.documentos" :key="a">
                <h5 class="mb-0"><strong>{{arch.codigo_sesion}}</strong></h5>
                <vs-row>
                    <vs-col sm="12" lg="4" v-for="(file, f) in arch.documentos" :key="f">
                        <div class="documentoBox shadow-sm">
                            <h6 class="mb-0"><strong>{{file.filename}}</strong></h6>
                            <hr>
                            <h6><small><strong>FECHA LÍMITE DE VISUALIZACIÓN</strong></small></h6>
                            <p>{{file.fecha_limite ? file.fecha_limite : 'Sin fecha límite'}}</p>
                            <h6><small><strong>DESCRIPCIÓN:</strong></small></h6>
                            <p>{{file.descripcion ? file.descripcion : 'Sin descripción'}}</p>
                            <vs-button
                                flat
                                md-menu-trigger
                                @click="getDocumentosDownload(file.id)"
                            >
                                Descargar documento
                            </vs-button>
                        </div>
                    </vs-col>
                </vs-row>
                </div>
            </vs-col> -->
        </vs-row>
    </div>
</template>
<script>
import alumnos from '../../../../../api/requests/alumno'
import evaluaciones from '../../../../../api/requests/docente/evaluaciones'
export default {
    props: [
        'general',
        'registroAcademico',
        'registroCounter'
    ],
    data(){
        return{
            correos: [],
            documento: [],
            arrayDocumentos: [],
        }
    },
    methods: {
        async getMaterialGeneral(){
            try{
                const registro_academicos = this.registroAcademico.registros_academicos
                const registros_id = []
                const academico = []
                registro_academicos.forEach(element => {
                    const id = element.registros_academicos_programa.find(i => i.status === 'actual')
                    registros_id.push(id)
                    academico.push({
                        institucion: element.institucion,
                        programa: element.programa,
                        registro: id,
                        documentos: []
                    })
                });
                let valor = 0
                for(const regitroA of registros_id) {
                    valor += 1
                    const params = {
                        ciclo_escolar_id: regitroA.ciclo_escolar_id,
                        registro_academico_id: regitroA.registro_academico_id
                    }
                    const {data: response} = await evaluaciones.getMaterialGeneral(params)
                    const ans = []
                    const materiasKey = Object.keys(response)
                    materiasKey.forEach(m => {
                        const obj = {
                            codigo_sesion: m,
                            documentos: response[m]
                        }
                        ans.push(obj)
                        // response[m].forEach(d => {
                        //     const obj = {
                        //         codigo_sesion: m,
                        //         documentos: d
                        //     }
                        //     ans.push(obj)
                        // })
                    })
                    academico.map(a => {
                        if(a.registro.registro_academico_id == regitroA.registro_academico_id){
                            a.documentos = ans
                        }
                    })
                    this.documento = academico
                    if(valor === registros_id.length){
                        console.log("termino")
                    }
                }
            }catch(error){

            }
        },
        async getDocumentosDownload(id){
          try{
            const url = '/api/documentos-docentes/'+ id
            window.open(url)
          }catch(error){
            console.log(error)
          }
        }
    },
    watch:{
        registroAcademico(){
            this.getMaterialGeneral()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
.hiperlink{
    color: rgb(50, 132, 240);
    font-weight: bold;
    cursor: pointer;
}
</style>

<style lang="scss" scoped>
.documentoBox{
    margin: 0.4rem;
    padding: 1rem;
    border-radius: 10px;
    border: 1px solid #dee2e6;
  }
    .estatus-alumno{
        display:inline-block;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
</style>
<style lang="scss" scoped>
// .permisos{
//     .encabezado{
//         border-radius: 14px 14px 0 0;
//         background: #F4F7F8;
//         padding: 10px 12px;
//     }
//     .sinInfo{
//         padding: 20px;
//         text-align: center;
//     }
//     details{
//         padding: 10px 12px;
//     }
//     details:not(:last-child){
//         border-bottom: 2px solid #ececec;
//     }
//     details summary{
//     font-size: 15px;
//     }
    
// }
details {
  padding: 0 1rem;
  width: 100%;
}
details + details {
  border-top: none;
}
details[open] {
    padding-bottom: 1em;
}  
summary {
  padding: 1rem 2em 1rem 0;
  font-size: 1.25rem;
  font-weight: bold;
  cursor: pointer;
}
.lineSub:not(:last-child){
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
</style>
